(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
class ProductTabs extends HTMLElement{connectedCallback(){if(this.dataset.initialized==='true')return;this.dataset.initialized='true';this.tabs=[...this.querySelectorAll('[role="tab"]')];this.panels=[...this.querySelectorAll('[role="tabpanel"]')];this.tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>this.selectTab(tab));tab.addEventListener('keydown',event=>this.handleTabKeydown(event,index))});this.querySelectorAll('[data-product-tabs-previous]').forEach(button=>button.addEventListener('click',()=>this.scrollProducts(button,-1)));this.querySelectorAll('[data-product-tabs-next]').forEach(button=>button.addEventListener('click',()=>this.scrollProducts(button,1)))}selectTab(selectedTab){const targetId=selectedTab.dataset.tabTarget;this.tabs.forEach(tab=>{const selected=tab===selectedTab;tab.setAttribute('aria-selected',String(selected));tab.tabIndex=selected?0:-1});this.panels.forEach(panel=>panel.hidden=panel.id!==targetId)}handleTabKeydown(event,index){if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;event.preventDefault();let next=index;if(event.key==='ArrowLeft')next=(index-1+this.tabs.length)%this.tabs.length;if(event.key==='ArrowRight')next=(index+1)%this.tabs.length;if(event.key==='Home')next=0;if(event.key==='End')next=this.tabs.length-1;this.tabs[next].focus();this.selectTab(this.tabs[next])}scrollProducts(button,direction){const track=button.closest('.product-tabs__products-wrap')?.querySelector('[data-product-tabs-track]');if(track)track.scrollBy({left:direction*track.clientWidth*.8,behavior:'smooth'})}}if(!customElements.get('product-tabs'))customElements.define('product-tabs',ProductTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-carousel"] && !Shopify.designMode) return;
  try {
    
  class VvVideoCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.stage = this.querySelector('[data-vv-carousel-stage]');
      this.viewport = this.querySelector('[data-vv-carousel-viewport]');
      this.cards = Array.from(this.querySelectorAll('[data-vv-video-card]'));
      this.previousButton = this.querySelector('[data-vv-carousel-previous]');
      this.nextButton = this.querySelector('[data-vv-carousel-next]');
      this.dialog = this.querySelector('[data-vv-video-dialog]');
      this.player = this.querySelector('[data-vv-video-player]');
      this.dialogMedia = this.querySelector('[data-vv-video-swipe]');
      this.titleElement = this.querySelector('[data-vv-video-title]');
      this.counterElement = this.querySelector('[data-vv-video-counter]');
      this.itemCount = this.cards.length;
      this.centerIndex = Math.floor((this.itemCount - 1) / 2);
      this.committedIndex = this.centerIndex;
      this.selectedIndex = this.centerIndex;
      this.modalIndex = this.centerIndex;
      this.touchStartX = 0;
      this.previousBodyOverflow = '';
      this.resizeTimer = null;

      if (!this.viewport || !this.itemCount) return;

      this.bindCarouselEvents();
      this.bindDialogEvents();

      this.handleResize = () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => this.layoutCards(), 100);
      };

      window.addEventListener('resize', this.handleResize);
      document.addEventListener('keydown', this.handleKeydown = (event) => {
        if (!this.dialog?.open) return;
        if (event.key === 'ArrowLeft') this.changeVideo(-1);
        if (event.key === 'ArrowRight') this.changeVideo(1);
        if (event.key === 'Escape') this.closeDialog();
      });

      requestAnimationFrame(() => this.layoutCards());
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      document.removeEventListener('keydown', this.handleKeydown);
      clearTimeout(this.resizeTimer);
    }

    isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    getSignedDistance(index, centerIndex) {
      let distance = (index - centerIndex + this.itemCount) % this.itemCount;
      if (distance > this.itemCount / 2) distance -= this.itemCount;
      return distance;
    }

    getSlotRatio(distance) {
      const slots = this.isMobile()
        ? [0, 0.62, 1.08, 1.46, 1.78, 2.05]
        : [0, 0.76, 1.28, 1.72, 2.1, 2.42];
      return slots[Math.min(distance, slots.length - 1)];
    }

    getScale(distance) {
      const scales = this.isMobile()
        ? [1, 0.92, 0.84, 0.77, 0.7, 0.64]
        : [1, 0.9, 0.81, 0.729, 0.6561, 0.59049];
      return scales[Math.min(distance, scales.length - 1)];
    }

    layoutCards() {
      const referenceCard = this.cards[this.centerIndex] || this.cards[0];
      const cardWidth = referenceCard?.getBoundingClientRect().width || (this.isMobile() ? 250 : 360);
      const mobileGap = Number.parseFloat(getComputedStyle(this).getPropertyValue('--vv-card-gap')) || 0;
      const visibleDistance = this.isMobile() ? 2 : 4;
      const selectedSlotDistance = this.getSignedDistance(this.selectedIndex, this.centerIndex);

      this.cards.forEach((card, index) => {
        const slotDistance = this.getSignedDistance(index, this.centerIndex);
        const absoluteSlotDistance = Math.abs(slotDistance);
        const visualDistanceFromSelected = Math.abs(slotDistance - selectedSlotDistance);
        const direction = slotDistance < 0 ? -1 : slotDistance > 0 ? 1 : 0;
        const gapOffset = this.isMobile() ? absoluteSlotDistance * mobileGap : 0;
        const x = direction * ((this.getSlotRatio(absoluteSlotDistance) * cardWidth) + gapOffset);
        const isSelected = index === this.selectedIndex;
        const scaleDistance = isSelected ? 0 : Math.max(1, visualDistanceFromSelected);
        const scale = this.getScale(scaleDistance);
        const isVisible = absoluteSlotDistance <= visibleDistance || this.itemCount <= 7;
        const zIndex = isSelected ? 50 : Math.max(1, 30 - scaleDistance);

        card.style.setProperty('--vv-x', `${x}px`);
        card.style.setProperty('--vv-scale', String(scale));
        card.style.setProperty('--vv-z', String(zIndex));
        card.style.setProperty('--vv-opacity', isVisible ? '1' : '0');
        card.classList.toggle('is-selected', isSelected);
        card.setAttribute('aria-pressed', String(isSelected));
        card.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      });
    }

    bindCarouselEvents() {
      this.cards.forEach((card, index) => {
        card.addEventListener('pointerenter', () => {
          if (this.isMobile()) return;
          this.selectedIndex = index;
          this.layoutCards();
        });

        card.addEventListener('click', (event) => {
          const playButton = event.target.closest('[data-vv-video-play]');
          this.committedIndex = index;
          this.selectedIndex = index;
          this.layoutCards();

          if (playButton) {
            event.stopPropagation();
            this.openDialog(index);
          }
        });

        card.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          this.committedIndex = index;
          this.selectedIndex = index;
          this.layoutCards();
        });
      });

      this.stage?.addEventListener('pointerleave', () => {
        if (this.isMobile()) return;
        this.selectedIndex = this.committedIndex;
        this.layoutCards();
      });

      this.previousButton?.addEventListener('click', () => this.changeCenter(-1));
      this.nextButton?.addEventListener('click', () => this.changeCenter(1));

      this.viewport.addEventListener('touchstart', (event) => {
        this.touchStartX = event.changedTouches[0]?.clientX || 0;
      }, { passive: true });

      this.viewport.addEventListener('touchend', (event) => {
        const touchEndX = event.changedTouches[0]?.clientX || 0;
        const difference = touchEndX - this.touchStartX;
        if (Math.abs(difference) >= 45) this.changeCenter(difference > 0 ? -1 : 1);
      }, { passive: true });
    }

    changeCenter(direction) {
      if (this.itemCount <= 1) return;

      const oldDistances = this.cards.map((_, index) => this.getSignedDistance(index, this.centerIndex));
      this.centerIndex = (this.centerIndex + direction + this.itemCount) % this.itemCount;
      this.committedIndex = this.centerIndex;
      this.selectedIndex = this.centerIndex;

      this.cards.forEach((card, index) => {
        const newDistance = this.getSignedDistance(index, this.centerIndex);
        if (Math.abs(newDistance - oldDistances[index]) > 1) card.classList.add('is-wrap-jump');
      });

      this.layoutCards();

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.cards.forEach((card) => card.classList.remove('is-wrap-jump'));
        });
      });
    }

    bindDialogEvents() {
      this.querySelector('[data-vv-video-close]')?.addEventListener('click', () => this.closeDialog());
      this.querySelector('[data-vv-video-previous]')?.addEventListener('click', () => this.changeVideo(-1));
      this.querySelector('[data-vv-video-next]')?.addEventListener('click', () => this.changeVideo(1));

      this.dialog?.addEventListener('click', (event) => {
        const protectedArea = event.target.closest(
          '.vv-video-carousel__dialog-media, .vv-video-carousel__dialog-arrow, .vv-video-carousel__close'
        );
        if (!protectedArea) this.closeDialog();
      });

      this.dialog?.addEventListener('close', () => this.releasePlayer());

      this.dialogMedia?.addEventListener('touchstart', (event) => {
        this.touchStartX = event.changedTouches[0]?.clientX || 0;
      }, { passive: true });

      this.dialogMedia?.addEventListener('touchend', (event) => {
        const touchEndX = event.changedTouches[0]?.clientX || 0;
        const difference = touchEndX - this.touchStartX;
        if (Math.abs(difference) >= 45) this.changeVideo(difference > 0 ? -1 : 1);
      }, { passive: true });
    }

    openDialog(index) {
      if (!this.dialog || !this.player || !this.cards[index]?.dataset.videoUrl) return;

      this.modalIndex = index;
      this.loadVideo();

      if (!this.dialog.open) {
        this.previousBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.dialog.showModal();
      }
    }

    closeDialog() {
      if (this.dialog?.open) this.dialog.close();
      else this.releasePlayer();
    }

    releasePlayer() {
      if (!this.player) return;
      this.player.pause();
      this.player.removeAttribute('src');
      this.player.removeAttribute('poster');
      this.player.load();
      document.body.style.overflow = this.previousBodyOverflow;
    }

    loadVideo() {
      const card = this.cards[this.modalIndex];
      const videoUrl = card?.dataset.videoUrl;
      if (!card || !videoUrl || !this.player || !this.dialogMedia) return;

      this.player.pause();
      this.player.src = videoUrl;

      if (card.dataset.videoPoster) this.player.poster = card.dataset.videoPoster;
      else this.player.removeAttribute('poster');

      this.dialogMedia.style.setProperty('--vv-dialog-ratio', card.dataset.videoRatio || '9 / 16');
      if (this.titleElement) this.titleElement.textContent = card.dataset.videoTitle || '';
      if (this.counterElement) this.counterElement.textContent = `${this.modalIndex + 1} / ${this.itemCount}`;

      this.player.load();
      const playPromise = this.player.play();
      if (playPromise) playPromise.catch(() => {});
    }

    changeVideo(direction) {
      if (!this.itemCount) return;

      let nextIndex = this.modalIndex;
      let attempts = 0;

      do {
        nextIndex = (nextIndex + direction + this.itemCount) % this.itemCount;
        attempts += 1;
      } while (!this.cards[nextIndex]?.dataset.videoUrl && attempts <= this.itemCount);

      if (!this.cards[nextIndex]?.dataset.videoUrl) return;

      this.modalIndex = nextIndex;
      this.centerIndex = nextIndex;
      this.committedIndex = nextIndex;
      this.selectedIndex = nextIndex;
      this.layoutCards();
      this.loadVideo();
    }
  }

  if (!customElements.get('vv-video-carousel')) {
    customElements.define('vv-video-carousel', VvVideoCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
